import React, { useState } from 'react';
import { Button, Popover } from 'antd';
import { SmileOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import EmojiPicker, { Categories, EmojiStyle, Theme } from 'emoji-picker-react';
import type { RootState } from '../store';

const EMOJI_CATEGORIES = [
    { category: Categories.SUGGESTED, name: 'Недавние' },
    { category: Categories.SMILEYS_PEOPLE, name: 'Смайлы и люди' },
    { category: Categories.ANIMALS_NATURE, name: 'Животные и природа' },
    { category: Categories.FOOD_DRINK, name: 'Еда и напитки' },
    { category: Categories.TRAVEL_PLACES, name: 'Путешествия' },
    { category: Categories.ACTIVITIES, name: 'Активности' },
    { category: Categories.OBJECTS, name: 'Предметы' },
    { category: Categories.SYMBOLS, name: 'Символы' },
    { category: Categories.FLAGS, name: 'Флаги' },
];

interface CommentEmojiPickerProps {
    onSelect: (emoji: string) => void;
    disabled?: boolean;
}

const CommentEmojiPicker: React.FC<CommentEmojiPickerProps> = ({ onSelect, disabled }) => {
    const isDark = useSelector((state: RootState) => Boolean(state.settings.theme?.isDark));
    const [open, setOpen] = useState(false);

    return (
        <Popover
            trigger="click"
            open={open}
            onOpenChange={setOpen}
            placement="topRight"
            arrow={false}
            zIndex={2000}
            getPopupContainer={() => document.body}
            styles={{ body: { padding: 0 } }}
            content={(
                <div className="task-emoji-picker">
                    <EmojiPicker
                        onEmojiClick={(emoji) => onSelect(emoji.emoji)}
                        theme={isDark ? Theme.DARK : Theme.LIGHT}
                        emojiStyle={EmojiStyle.NATIVE}
                        searchPlaceholder="Поиск…"
                        searchClearButtonLabel="Очистить"
                        autoFocusSearch={false}
                        lazyLoadEmojis
                        previewConfig={{ showPreview: false }}
                        width={320}
                        height={360}
                        categories={EMOJI_CATEGORIES}
                    />
                </div>
            )}
        >
            <Button
                type="text"
                shape="circle"
                className="task-comments__emoji"
                icon={<SmileOutlined />}
                disabled={disabled}
                aria-label="Эмодзи"
                title="Эмодзи"
            />
        </Popover>
    );
};

export default CommentEmojiPicker;
